import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import DefaultLayout from '~/pages/_layouts/DefaultLayout';
import { languageOptions } from '~/utils/languageOptions';
import { FoldedMenu } from '~/components';
import * as S from './styles';

export default function Login() {
  const { t } = useTranslation();
  return (
    <DefaultLayout>
      <S.MessageContainer width={30}>
        <S.Message>{t('azureFailure')}</S.Message>
        <S.BackButton>
          <Link to={{ pathname: '/', state: { shouldGoToLogin: true } }}>
            {t('return')}
          </Link>
        </S.BackButton>
      </S.MessageContainer>
      <FoldedMenu label={t('languageId')} options={languageOptions()} />
    </DefaultLayout>
  );
}
